export const backgroundColor = "#f7f7f7";

// Neutral Colors
export const white = "#ffffff";
export const offWhite = "#f2f3f5";
export const gray = "#b0b8bf";
export const grayBtn = "#d3dce6";
export const grayBg = "#f2f3f5";
export const grayLt = "#dadada";
export const grayLtr = "#e5e6e7";
export const grayDk = "#4a525a";
export const black = "#24272b";
export const blacker = "#231f20";
export const darken = "rgba(4, 14, 53, 0.1)";

// Blue Brand Color
export const brandBlue = "#004bed";
export const brandBlueDk = "#0033a1";
export const brandBlueLt = "#0876e8";
export const brandBlueLtr = "#11a9f0";

// Secondary Colors
export const red = "#e71d36";
export const orange = "#f67840";
export const orangeDk = "#f44c3f";
export const yellow = "#facf43";

//Colors
export const brandDanger = "#e71d36";
export const error = "#e71d36";
export const brandSuccess = "#20bf55";
export const green = "#20bf55";
export const greenLt = "#3ddc97";

//Bootstrap Colors
export const primary = "export const brandBlue";
export const secondary = "export const grayDk";
export const warning = "export const yellow";
export const success = "export const brandSuccess";
export const info = "export const brandBlueLt";
export const dark = "export const black";
export const light = "export const grayLt";

// Alt Colors
export const blurBackgroundColor = "rgba(255, 255, 255, 0.5)";
export const blurBackgroundColorMore = "rgba(255, 255, 255, 0.8)";
export const blurBackgroundColorXMore = "rgba(255, 255, 255, 0.92)";

// Shadows
export const transparentShadow = "0 6px 16px 0 rgba(0, 0, 0, 0)";
export const wellShadow = "0 6px 16px 0 rgba(0, 0, 0, 0.15)";
export const wellShadowLight = "0 6px 16px 0 rgba(0, 0, 0, 0.08)";
export const heavyShadow = "0 6px 16px 0 rgba(0, 0, 0, 0.15)";
export const tightShadow = "0 3px 8px 0 rgba(0, 0, 0, 0.25)";
export const boxShadow = "0px 8px 16px 0px #24272b26";

// Gradients
export const blueGradient = `linearGradient(136.43deg, ${brandBlueLt} 0%, ${brandBlue} 100%)`;
export const lighterBlueGradient = `linearGradient(136.43deg, ${brandBlueLtr} 0%, ${brandBlue} 100%)`;
export const darkBlueGradient = `linearGradient(136.43deg, ${brandBlueDk} 0%, ${brandBlue} 100%)`;
export const greenBlueGradient = `linearGradient(136.43deg, ${greenLt} 0%, ${brandBlue} 100%)`;
export const greenBlueGradientReversed = `linearGradient(136.43deg, #0961e0 0%, #35c9a2 100%)`;
export const greenGradient = `linearGradient(136.43deg, ${greenLt} 0%, ${green} 100%)`;
export const blackGradient = `linearGradient(136.06deg, ${grayDk} 0%, ${black} 100%)`;
export const lightGrayGradient = `linearGradient(136.06deg, ${offWhite} 0%, ${grayLt} 100%)`;
export const orangeGradient = `linearGradient(136.06deg, ${orange} 0%, ${orangeDk} 100%)`;
export const blackGradientSemiTransparent = `linearGradient(136.06deg, rgba(74, 82, 90, 0.8) 0%, rgba(36, 39, 43, 0.8) 100%)`;

//Texts
export const fontColor = "export const black";
export const fontSize = "16px";
export const mFontSize = "18px";
export const lFontSize = "20px";
export const xlFontSize = "24px";
export const xxlFontSize = "32px";
export const xxxlFontSize = "36px";
export const sFontSize = "14px";
export const xsFontSize = "12px";
export const xxsFontSize = "10px";
export const iconSizeGiant = "70px";
export const fontColorError = "export const error";
export const fontSizeError = "9px";

//Fields
export const fieldHeight = "39px";
export const fieldBackgroundColor = "#ffffff";
export const placeholderColor = "#24272b49";
export const placeholderColorDark = "#ffffff57";

//Spacing
export const margin = "10px";
export const marginSm = "export const margin / 2";
export const padding = "10px";
export const paddingLg = "18px";
export const bootstrapGutter = "5px";
export const formFieldMargin = "export const bootstrapGutter";
export const pagePadding = "16px";
export const pageWidth = "1110px";
export const footerHeight = "65px";

//Responsive Breakpoints
export const phone = '~"only screen and (maxWidth: 480px)"';
export const xs = '~"only screen and (maxWidth: 575px)"';
export const small = '~"only screen and (maxWidth: 768px)"';
export const eighttwentysix = '~"only screen and (maxWidth: 826px)"';
export const medium = '~"only screen and (maxWidth: 992px)"';
export const tablet = '~"only screen and (maxWidth: 1024px)"';
export const fourteenforty = '~"only screen and (maxWidth: 1440px)"';
export const large = '~"only screen and (minWidth: 1530px)"';

//Borders
export const separatorBorderWidth = "1px";
export const borderRadius = "3px";
export const borderRadius2x = "6px";
export const borderRadiusLg = "14px";
export const fieldBorderColor = "export const grayLtr";
export const fieldBorderActiveColor = "export const grayDk";
export const fieldBorderWidth = "1px";
export const fieldBorder = "solid export const fieldBorderWidth export const fieldBorderColor";
export const fieldErrorBorderWidth = "2px";
export const fieldBorderActive = "solid export const fieldBorderWidth export const fieldBorderActiveColor";
export const sectionDivider = "solid 2px export const grayLtr";

//Wells
export const wellBackgroundColor = "export const white";
export const wellOutlineColor = "export const grayLtr";
export const wellPadding = "40px";
export const wellPaddingMobile = "12px";
